import React from 'react';
import { AlertCircleIcon, InfoIcon, CheckCircleIcon, XIcon, XCircleIcon, ClockIcon } from 'lucide-react';
import { useClosingAssistant } from '../../contexts/ClosingAssistantContext';
export const InsightsPanel: React.FC = () => {
  const {
    insights,
    dismissInsight,
    clearInsights
  } = useClosingAssistant();
  const activeInsights = insights.filter(insight => !insight.dismissed);
  if (activeInsights.length === 0) {
    return <div className="p-4 text-center" data-id="element-923">
        <div className="p-3 rounded-full bg-gray-100 inline-flex items-center justify-center mb-2" data-id="element-924">
          <InfoIcon className="h-6 w-6 text-gray-400" data-id="element-925" />
        </div>
        <p className="text-sm text-gray-500" data-id="element-926">No active insights yet.</p>
        <p className="text-xs text-gray-400 mt-1" data-id="element-927">
          Insights will appear as the customer interacts with the product.
        </p>
      </div>;
  }
  return <div className="p-2" data-id="element-928">
      <div className="flex justify-between items-center mb-2 px-2" data-id="element-929">
        <h4 className="text-xs font-medium text-gray-500" data-id="element-930">
          REAL-TIME INSIGHTS
        </h4>
        <button onClick={clearInsights} className="text-xs text-gray-500 hover:text-gray-700" data-id="element-931">
          Clear all
        </button>
      </div>
      <div className="space-y-2" data-id="element-932">
        {activeInsights.map(insight => <div key={insight.id} className={`p-3 rounded-lg relative border ${insight.severity === 'success' ? 'bg-green-50 border-green-200' : insight.severity === 'warning' ? 'bg-yellow-50 border-yellow-200' : insight.severity === 'error' ? 'bg-red-50 border-red-200' : 'bg-blue-50 border-blue-200'}`} data-id="element-933">
            <div className="flex" data-id="element-934">
              <div className="mr-2 mt-0.5" data-id="element-935">
                {insight.severity === 'success' && <CheckCircleIcon className="h-4 w-4 text-green-500" data-id="element-936" />}
                {insight.severity === 'warning' && <AlertCircleIcon className="h-4 w-4 text-yellow-500" data-id="element-937" />}
                {insight.severity === 'error' && <XCircleIcon className="h-4 w-4 text-red-500" data-id="element-938" />}
                {insight.severity === 'info' && <InfoIcon className="h-4 w-4 text-blue-500" data-id="element-939" />}
              </div>
              <div className="flex-1" data-id="element-940">
                <p className="text-sm font-medium text-gray-800" data-id="element-941">
                  {insight.message}
                </p>
                <div className="flex items-center mt-1" data-id="element-942">
                  <ClockIcon className="h-3 w-3 text-gray-400 mr-1" data-id="element-943" />
                  <span className="text-xs text-gray-500" data-id="element-944">
                    {insight.timestamp.toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit'
                })}
                  </span>
                  {insight.category && <span className="ml-2 text-xs px-1.5 py-0.5 bg-white bg-opacity-50 rounded text-gray-600" data-id="element-945">
                      {insight.category}
                    </span>}
                </div>
              </div>
              <button onClick={() => dismissInsight(insight.id)} className="ml-2 text-gray-400 hover:text-gray-600" data-id="element-946">
                <XIcon className="h-3 w-3" data-id="element-947" />
              </button>
            </div>
          </div>)}
      </div>
    </div>;
};